import { Injectable } from '@angular/core';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { EmailShippingLabel } from '../models/email-shipping-label.model';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';

@Injectable()
export class EmailShippingLabelService {

  constructor(private httpClientService: HttpClientService,
     private apiEndpointService: ApiEndpointService) {
  }


  /**
   * Upload Files.
   *
   * @param {FormData} formData
   * @returns {Observable<any>}
   */
  public uploadFiles(formData): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('uploadFiles')).toString();
    return this.httpClientService.postFormData<any>(endpoint, formData);
  }


  /**
   * Drop Shipment Label email.
   *
   * @param {EmailShippingLabel} data
   * @returns {Observable<any>}
   */
  public dropShipmentLabel(data: EmailShippingLabel): Observable<any> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('dropShipmentLabel')).toString();
    return this.httpClientService.post<any>(endpoint, data);
  }
}
